import { Adjustment, Asset, Company, Loan, Note, Payment, TAssetId, TCompanyId, TLoanId, User } from '/src/lib/models';
import { ISODateTimeString } from '/src/lib/types';

/**
 * Enums
 */
export enum AssetStatus {
  Open = 'open',
  Closed = 'closed',
  Pending = 'pending',
  ShortPay = 'short-pay',
  OverPaid = 'over-paid',
  PaidInFull = 'paid-in-full',
}

export enum AssetType {
  'CA LCFS' = 'CA LCFS',
  'CA FCI' = 'CA FCI',
  'OR CFP' = 'OR CFP',
  'WA CFS' = 'WA CFS',
  'BC LCFS' = 'BC LCFS',
  'CAN CFR' = 'CAN CFR',
  'Other' = 'Other',
}

/**
 * List Assets
 */
export type TListAssetsRequest = {
  loanId?: TLoanId;
  companyId?: TCompanyId;
};

export type TListAssetsResponse = Asset[];

/**
 * Get Asset
 */
export type TGetAssetRequest = {
  id: TAssetId;
};

export type TGetAssetResponse = Asset | undefined;

/**
 * Create Asset
 */
export type CreateAssetForm = {
  loan?: Loan;
  company?: Company;
  name: string;
  assetType?: AssetType;
  value: string;
  originalValue?: string;
  program?: string;
  paymentSchedule?: string;
  nextDate?: Date;
  companyComments?: Note[];
  socketComments?: Note[];
  effectiveDate: Date;
  files?: string[];
  status?: AssetStatus;
  startDate?: Date;
  endDate?: Date;
  initialPaymentAmount?: string;
  adminFee?: string;
  discountFee?: string;
  lateFee?: string;
  currentAdjustments?: string;
};

export type TCreateAssetRequest = {
  loan?: TLoanId;
  company?: TCompanyId;
  name: string;
  assetType?: AssetType;
  value: number;
  originalValue?: number;
  program: string;
  paymentSchedule: string;
  nextDate: Date;
  companyComments?: Note[];
  socketComments?: Note[];
  effectiveDate: ISODateTimeString;
  files?: string[];
  status?: AssetStatus;
  startDate?: Date;
  endDate?: Date;
  initialPaymentAmount?: number;
  adminFee?: number;
  discountFee?: number;
  lateFee?: number;
};

export type TCreateAssetResponse = Asset | undefined;

/**
 * Update Asset
 */
export type TUpdateAssetRequest = {
  _id: TAssetId;
  adjustments: Adjustment[];
  adminFee: number;
  assetType: AssetType;
  company: TCompanyId;
  companyComments: Note[];
  created: ISODateTimeString;
  discountFee: number;
  effectiveDate: ISODateTimeString;
  endDate: ISODateTimeString;
  expectedResidualPayment: number;
  feeBalance: number;
  files: string[];
  initialPaymentAmount: number;
  lateFee: number;
  loan: TLoanId;
  name: string;
  nextDate: ISODateTimeString;
  originalValue: number;
  payments: Payment[];
  paymentSchedule: string;
  socketComments: Note[];
  startDate: ISODateTimeString;
  status: AssetStatus;
  user: Partial<User>;
  value: number;
};

export type TUpdateAssetResponse = Asset | undefined;

/**
 * Delete Asset
 */
export type TDeleteAssetResponse = Asset | undefined;
